import React from "react";
import {useTranslation} from "react-i18next";
// Project imports
import {InformationDialog} from "./dialogs";

interface MapacompassComingSoonDialogProps {
    open: boolean;
    onClose: () => void;
}

export const MapacompassComingSoonDialog: React.FC<MapacompassComingSoonDialogProps> = (
    props: MapacompassComingSoonDialogProps
) => {
    const [t] = useTranslation("common");
    return (
        <InformationDialog
            id="mapacompass-coming-soon"
            title={t("mapacompassComingSoon.title")}
            text={t("mapacompassComingSoon.text")}
            open={props.open}
            onClose={props.onClose}
        />
    );
};

export default MapacompassComingSoonDialog;
